import { Modal, TypographyStylesProvider } from '@mantine/core';
import { stripUnsafeHtml } from '@/lib/sanitize';
import { DEFAULT_PRIVACY_NOTICE_HTML } from '@/lib/copy';
import { useCopy, contactVars, fillPlaceholders } from '@/lib/settings';

/**
 * Renders settings.privacyNoticeHtml (script-stripped) or the built-in POPIA notice. The API
 * already fills {deleteDataEmail}/{supportEmail}; we fill again client-side as a fallback.
 */
export function PrivacyNoticeContent() {
  const { t, settings } = useCopy();
  const raw = settings.privacyNoticeHtml?.trim() || DEFAULT_PRIVACY_NOTICE_HTML;
  const html = stripUnsafeHtml(fillPlaceholders(raw, contactVars(settings, t('app.name'))));
  return (
    <TypographyStylesProvider fz="sm">
      {/* Admin-authored HTML; <script>/<iframe>/on* handlers removed in stripUnsafeHtml. */}
      <div dangerouslySetInnerHTML={{ __html: html }} />
    </TypographyStylesProvider>
  );
}

export function PrivacyNoticeModal({ opened, onClose }: { opened: boolean; onClose: () => void }) {
  return (
    <Modal opened={opened} onClose={onClose} title="Privacy and your data" size="lg" centered>
      <PrivacyNoticeContent />
    </Modal>
  );
}
